<template>
  <div class="join-us">
    <Header :class="{ hidden: isHidden }"></Header>
    <div class="join-us-title AlimaBold fs230 fcF5F5F5">
      Join Us
      <div class="join-us-name my600 fs60 fc000000">
        加入我们
        <div class="title-line"></div>
      </div>
      <img src="@/assets/img/index/line1.png" class="line1-img" alt="" />
    </div>
    <div class="job-type">
      <div class="job-type-name">
        <div
          class="name-item my400 fs24 fc000000"
          :class="{ 'item-activate': isActive(index), my600: isActive(index) }"
          v-for="(item, index) in jobTypeList"
          :key="index"
          @click="toPath(index)">
          {{ item }}
        </div>
      </div>
      <div class="job-table-head">
        <div class="table-head-name">
          <div
            class="head-name-item my600 fs24 fc000000"
            v-for="(item, index) in headNameList"
            :key="index">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="job-table-body">
        <router-view></router-view>
        <div class="job-second"></div>
        <div class="job-thired"></div>
        <div class="job-fourth"></div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script setup>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import { ref, onMounted, onBeforeUnmount } from "vue";
  import { useRoute, useRouter } from "vue-router";

  const route = new useRoute();
  const router = new useRouter();

  const jobTypeList = ref(["产品/设计类", "研发类", "实习类", "职能类"]);
  const headNameList = ref(["职位", "工作地点", "发布时间"]);

  const isHidden = ref(false);
  let lastScrollTop = 0;

  const handleScroll = () => {
    const currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > lastScrollTop && currentScroll > 60) {
      isHidden.value = true; // 下滑：隐藏
    } else {
      isHidden.value = false; // 上滑：显示
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  };

  const toPath = (index) => {
    if (index == 0) {
      router.push("/jobDesign");
    } else if (index == 1) {
      router.push("/jobTechnology");
    } else if (index == 2) {
      router.push("/jobStudent");
    } else if (index == 3) {
      router.push("/jobFunction");
    }
  };

  const isActive = (index) => {
    const path = route.path;
    if (index === 0) return path.includes("/jobDesign");
    if (index === 1) return path.includes("/jobTechnology");
    if (index === 2) return path.includes("/jobStudent");
    if (index === 3) return path.includes("/jobFunction");
    return false;
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
  });
</script>
<style lang="less" scoped>
  .join-us {
    display: flex;
    flex-direction: column;
    width: 100%;

    .join-us-title {
      position: relative;
      margin-top: 170px;
      width: 774px;
      height: 210px;

      .join-us-name {
        position: absolute;
        left: 174px;
        top: 25px;

        .title-line {
          margin-top: -25px;
          width: 240px;
          height: 24px;
          background: #d3fea3;
        }
      }

      .line1-img {
        position: absolute;
        top: -79px;
        right: -600px;
        width: 147px;
        height: 327px;
        margin-top: 10px;
      }
    }

    .job-type {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      margin: 0 auto;
      margin-top: 100px;
      width: 1576px;

      .job-type-name {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        width: 100%;
        height: 82px;
        background: #ffffff;
        box-shadow: 0px 0px 29px 0px #949494;
        border-radius: 20px;

        .name-item {
          width: 394px;
          height: 82px;
          line-height: 82px;
          text-align: center;
          border-radius: 10px 10px 10px 10px;
          cursor: pointer;
        }

        .item-activate {
          background: #d3fea3;
          border-radius: 10px 10px 10px 10px;
        }
      }

      .job-table-head {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        width: 1182px;
        height: 100px;

        .table-head-name {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          width: 100%;
          height: 100px;

          .head-name-item {
            width: 394px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            cursor: default;
          }
        }
      }

      .job-table-body {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-bottom: 200px;
        width: 100%;
        box-shadow: 0px 0px 29px 0px #949494;
        border-radius: 20px !important;
      }
    }
  }
</style>
